import { filterDepositionPassLabels } from './floorSheetMisfirePrefill'
import type { AggregateResult } from './weldParameterAggregator'

/**
 * Resolve which pass labels to show on the Welding Parameters matrix.
 * WPS pass sequence is preferred when it overlaps aggregate data; when aggregate
 * passes are entirely disjoint (e.g. Data360 limits pass "-"), use aggregate order.
 * Root Misfire passes are excluded — they belong on the Floor Sheet misfire record.
 */
export function resolveWeldParametersPassLabels(
  wpsPassLabels: string[],
  aggregate: AggregateResult | null | undefined
): string[] {
  if (!aggregate?.rows?.length) {
    return filterDepositionPassLabels(wpsPassLabels)
  }

  const aggregatePasses = aggregate.rows.map((row) => row.pass)
  const aggregateSet = new Set(aggregatePasses)
  const wpsSet = new Set(wpsPassLabels)
  const hasOverlap = wpsPassLabels.some((pass) => aggregateSet.has(pass))

  if (!hasOverlap) {
    return filterDepositionPassLabels(Array.from(new Set(aggregatePasses)))
  }

  const seen = new Set<string>()
  const merged: string[] = []
  for (const pass of wpsPassLabels) {
    if (!seen.has(pass)) {
      merged.push(pass)
      seen.add(pass)
    }
  }
  for (const pass of aggregatePasses) {
    if (!seen.has(pass)) {
      merged.push(pass)
      seen.add(pass)
    }
  }
  return filterDepositionPassLabels(merged)
}
